import React from 'react';
import PropTypes from 'prop-types';
import WalletProp from '../../proptype/walletProp';
import CommissionsWalletCardListItem from './CommissionsWalletCardListItem';
import CommissionsWalletCardNavigation from './CommissionsWalletCardNavigation';

export default function CommissionsWalletCardList(props) {
  const { wallets, activeWalletIndex, onNextWallet, onPreviousWallet } = props;

  const canGoPrevious = activeWalletIndex > 0;
  const canGoNext = activeWalletIndex < wallets.length - 1;

  return (
    <div className="commissions-wallet-picker-cards">
      <CommissionsWalletCardNavigation
        disabled={!canGoPrevious}
        onClick={onPreviousWallet}
      />
      <CommissionsWalletCardListItem wallet={wallets[activeWalletIndex]} />
      <CommissionsWalletCardNavigation
        disabled={!canGoNext}
        isNext
        onClick={onNextWallet}
      />
    </div>
  );
}

CommissionsWalletCardList.propTypes = {
  wallets: PropTypes.arrayOf(PropTypes.shape(WalletProp.propType).isRequired)
    .isRequired,
  activeWalletIndex: PropTypes.number.isRequired,
  onNextWallet: PropTypes.func.isRequired,
  onPreviousWallet: PropTypes.func.isRequired,
};
